import { render, staticRenderFns } from "./newest_recurring.vue?vue&type=template&id=b8dad1fa"
import script from "./newest_recurring.vue?vue&type=script&lang=js"
export * from "./newest_recurring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slider: require('/home/forge/meidenvanholland.nl/components/slider.vue').default})
